module.exports = __webpack_public_path__ + "lazer6.png?9f9d9c98b072bfc2362b9cc5d1d53509";